'use client';

import { createAuthClient } from 'better-auth/react';
import { adminClient, twoFactorClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
  // The address the page was opened on, not the one in .env. The same server
  // is reached as `localhost` on the machine running it and by its network
  // address from everyone else; a fixed URL made the other one a cross-origin
  // request the browser blocks ("Failed to fetch" at sign-in). Same-origin
  // always, like the tRPC client's relative `/api/trpc`. The env value only
  // remains for the server render, where there is no window.
  baseURL:
    typeof window !== 'undefined'
      ? window.location.origin
      : process.env.NEXT_PUBLIC_BETTER_AUTH_URL,
  // Mirror of server/auth/index.ts — a plugin missing here means its methods
  // simply do not exist on authClient, with no build error to say so.
  //
  // twoFactorClient is deliberately given no options. Both `twoFactorPage` and
  // `onTwoFactorRedirect` navigate for you, and the only tool they have is
  // window.location — a full document load that throws away the router cache
  // and flashes white. LoginForm reads `data.twoFactorRedirect` off the sign-in
  // result and routes itself instead.
  plugins: [adminClient(), twoFactorClient()],
});

export const { signIn, signUp, signOut, useSession, getSession } = authClient;
